import { InvitationInput } from '~/types/graphql'
import { useRouter } from 'next/router'

export type Invitation = {
  email: string
  input: InvitationInput
  invitedBy: string
  workspaceName: string
}

export const useInvitation = (): Invitation | undefined => {
  const { query } = useRouter()
  const { email, token, tokenId, invitedBy, workspaceName } = query

  if (!email || !token || !tokenId || !invitedBy || !workspaceName) {
    return
  }

  return {
    email: email as string,
    input: {
      id: tokenId as string,
      token: token as string,
    },
    invitedBy: invitedBy as string,
    workspaceName: workspaceName as string,
  }
}
